import dayjs from 'dayjs';

export const parseSelectedToIso = (
  comparisonDate: Date | null,
  comparisonType: string,
  compareTo: string,
  compareToUnit: string
): string => {
  let selectedDateString = '';
  if (comparisonDate && comparisonType === 'absolute') {
    selectedDateString = dayjs(comparisonDate).format('YYYY-MM-DD');
  }
  if (compareTo.length > 0 && comparisonType === 'relative') {
    const relativeDate = parseRelativeDateSelection(Number(compareTo), compareToUnit);
    selectedDateString = dayjs(relativeDate).format('YYYY-MM-DD');
  }
  return selectedDateString;
};

export const parseRelativeDateSelection = (compareTo: number, compareToUnit: string) => {
  const today = new Date();

  switch (compareToUnit) {
    case 'd': {
      today.setDate(today.getDate() - compareTo);
      break;
    }
    case 'm': {
      today.setMonth(today.getMonth() - compareTo);
      break;
    }
    case 'y': {
      today.setFullYear(today.getFullYear() - compareTo);
      break;
    }
  }

  return today;
};
